<div class="dialog-content">
  <form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
      <h2 class="headline m-0 flex-auto">{{ 'fileManager.renameFile' | translate }}</h2>
    </div>

    <mat-divider class="text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col">
      <div class="flex flex-col gap-2">
        <mat-form-field class="flex-auto" *ngFor="let lang of languages">
          <mat-label>
            <span class="flex items-center gap-2">
              <mat-icon [svgIcon]="lang.flag" class="flag-icon"></mat-icon>
              {{ 'fileManager.labelField' | translate:{lang: lang.name} }}
            </span>
          </mat-label>
          <input [formControlName]="'label_' + lang.code" matInput>
        </mat-form-field>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">{{ 'common.cancel' | translate }}</button>
      <button color="primary" mat-flat-button type="submit">{{ 'common.save' | translate }}</button>
    </mat-dialog-actions>
  </form>
</div>
